 export const  defaultOneMonthDate = ()=>{
    const today = new Date();
    // One month ago
    const lastMonth = new Date(today);   // clone so we don't mutate today
    lastMonth.setMonth(lastMonth.getMonth() - 1);

    // Helper to format as YYYY-MM-DD
    const format = (d) => d.toISOString().split('T')[0];

    return {
        today:format(today),
        lastMonth:format(lastMonth)
    };
  }